import { useEffect } from 'react';
import { useAuthStore } from '@/stores';
import { useNavigate } from 'react-router-dom';

interface AuthProviderProps {
    children: React.ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
    const initialize = useAuthStore(state => state.initialize);
    const isAuthenticated = useAuthStore(state => state.isAuthenticated);
    const navigate = useNavigate();

    useEffect(() => {
        initialize();
    }, [initialize]);

    useEffect(() => {
        const currentPath = window.location.pathname;
        if (!isAuthenticated && currentPath !== '/login') {
            navigate('/login');
        }
    }, [isAuthenticated, navigate]);

    return <>{children}</>;
}
